<template>
  <div>
    <div class="d-flex align-center mb-6 px-1">
      <div class="caption font-weight-black text-uppercase tracking-widest grey--text">Listado de Categorías</div>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        class="font-weight-black text-uppercase tracking-widest rounded-lg px-8 h-44 shadow-sm"
        @click="update(-1)"
      >
        <v-icon left size="16">fas fa-plus</v-icon>
        Nueva Familia
      </v-btn>
    </div>

    <!-- Search Section -->
    <v-card outlined class="bg-lightgrey border-dashed pa-4 mb-6 d-flex align-center rounded-xl">
      <v-text-field
        v-model="search"
        placeholder="Buscar familia por nombre..."
        prepend-inner-icon="fas fa-search"
        outlined
        dense
        hide-details
        class="modern-search-input bg-white elevation-0"
        :loading="loading"
      ></v-text-field>
    </v-card>

    <!-- Table -->
    <v-card outlined class="modern-table-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="families"
        :items-per-page="10"
        :loading="loading"
        :search="search"
        dense
        class="modern-data-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-angle-double-left',
          lastIcon: 'fas fa-angle-double-right',
          prevIcon: 'fas fa-angle-left',
          nextIcon: 'fas fa-angle-right'
        }"
      >
        <template v-slot:item.id="{ item }">
          <span class="caption font-weight-black grey--text opacity-60">ID #{{ item.id }}</span>
        </template>
        
        <template v-slot:item.name="{ item }">
          <span class="body-2 font-weight-black primary--text">{{ item.name }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon color="primary" small @click.stop="update(item.id)">
            <v-icon size="16">fas fa-edit</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Refined Dialog -->
    <v-dialog v-model="showDialog" max-width="460" content-class="modern-dialog" persistent>
      <v-card class="overflow-hidden rounded-xl bg-white">
        <family-create-update :id="family" @updated="fetch" @close="showDialog=false"/>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fetchFamilies } from '@/api/stocks'
import notifications from '@/utils/notifications'
import FamilyCreateUpdate from '@/components/stocks/FamilyCreateUpdate'

export default {
  name: 'Families',
  components: { FamilyCreateUpdate },
  data() {
    return {
      loading: false,
      family: -1,
      families: [],
      search: '',
      showDialog: false,
      headers: [
        { text: 'Ref', align: 'start', value: 'id', class: 'caption font-weight-black tracking-widest grey--text', width: '100px' },
        { text: 'Nombre de la Familia', align: 'start', value: 'name', class: 'caption font-weight-black tracking-widest grey--text' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false, class: 'caption font-weight-black tracking-widest grey--text', width: '80px' }
      ],
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        const res = await fetchFamilies()
        this.families = res
      } catch (err) {
        notifications.showError('Error cargando familias')
      } finally {
        this.loading = false
      }
    },
    update(id) {
      this.family = id
      this.showDialog = true
    }
  },
  async mounted() {
    this.fetch()
  }
}
</script>

<style scoped>
.tracking-widest { letter-spacing: 1.5px; }
.bg-lightgrey { background-color: #f8fbfc !important; }
.border-dashed { border: 1px dashed #e0e4e8 !important; }
.h-44 { height: 44px !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(var(--v-success-base), 0.2) !important; }
.opacity-60 { opacity: 0.6; }

.modern-search-input { border-radius: 24px !important; width: 320px; }
.modern-search-input >>> fieldset { border-radius: 24px !important; border: 1px solid #e0e4e8 !important; }

.modern-table-card { border-radius: 12px !important; border: 1px solid #e0e4e8 !important; }
.modern-data-table >>> .v-data-table-header { background-color: #f8fbfc !important; }
.modern-data-table >>> th { height: 48px !important; text-transform: uppercase; font-size: 0.75rem !important; }
.modern-data-table >>> td { height: 56px !important; }

.modern-dialog { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; }
</style>